<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    cardClasses: {
      type: String,
      default: '',
    },
    closeable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <transition
    enter-active-class="animate__fadeIn animation_duration-200ms"
    leave-active-class="animate__fadeOut animation_duration-200ms"
  >
    <div
      v-if="modelValue"
      as="div"
      class="animate__animated fixed inset-0 z-20 flex items-center justify-center bg-gray-700 bg-opacity-75 print:absolute print:block print:h-full print:overflow-visible"
      @mousedown="$emit('update:modelValue', false)"
    >
      <div
        class="flex h-full max-h-[90vh] transform flex-col overflow-visible rounded-lg bg-white px-5 py-7 text-left align-bottom shadow-xl transition-all md:h-auto print:block print:!h-full print:!min-h-full print:overflow-visible print:shadow-none"
        :class="[cardClasses]"
        @mousedown.stop
      >
        <div v-if="title && title.length" class="mb-8 flex">
          <h1 class="text-2xl font-medium text-gray-800">
            {{ title }}
          </h1>
        </div>
        <div class="flex-grow overflow-y-auto print:bg-white">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>
